import React, { useMemo } from 'react';
import {DatePicker} from "antd";

import Form from "core/ui-kit/form";
import { Row, Col } from "core/ui-kit/layout";
import Icon from "core/ui-kit/icon";

import { useTranslation } from "core/hooks/useTranslation";
import useDate from "core/hooks/useDate";
import useDevice from 'core/hooks/useDevice';

import FormRulesBuilder from 'core/helpers/common/formRulesBuilder';
import { COMMISSION_EDIT_FIELDS } from '../constants';

const EditForm = ({
    formInstance,
    startDate = null,
    endDate = null,
    isActive,
    isScheduled,
    onFormValuesChange,
}) => {
    const { t } = useTranslation();
    const { dateService } = useDate();
    const { isMobile } = useDevice();

    const datePickerValue = [
        startDate ? dateService.makeUtcDateToLocal(startDate) : "",
        endDate ? dateService.makeUtcDateToLocal(endDate) : "",
    ];

    const initialValues = {
        [COMMISSION_EDIT_FIELDS.START_AND_END_DATE]: datePickerValue,
    };

    const disabled = useMemo(() => {
        if (isActive) {
            return [true, false]
        }
        if (isScheduled) {
            return [false, false]
        }
        return [];
    }, [isActive, isScheduled]);

    const onFormValuesChangeHandler = () => {
        onFormValuesChange(initialValues);
    }

    return (
        <div>
            <Form
                form={formInstance}
                initialValues={initialValues}
                onValuesChange={onFormValuesChangeHandler}
            >
                <Row gutter={[16, 0]}>
                    <Col span="24">
                        <Form.Item
                            name={COMMISSION_EDIT_FIELDS.START_AND_END_DATE}
                            label={`${t('backoffice.commissionplans.startAndEndTime')} *`}                            
                            rules={
                                new FormRulesBuilder(t).required({whitespace: false}).build()
                            }
                        >
                            <DatePicker.RangePicker
                                format={`${dateService.getFormat(false)} HH:00`}
                                showTime={{
                                    format: "HH"
                                }}
                                allowEmpty={[false, true]}
                                disabled={disabled}
                                disabledDate={d => dateService.isBefore(d, dateService.getNow())}
                                className="rt--datepicker rt--table-datepicker-search-with-time"
                                dropdownClassName="rt--datepicker-popup rt--datepicker-withtime-popup rt--datepicker-only-hours"
                                suffixIcon={<Icon name="date" />}
                                showToday={true}
                                separator={<div className='rt--table-timepicker-separator' />}
                                inputReadOnly={isMobile}
                            />
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </div>
    )
}

export default EditForm;
